/**
 * EventHub - Simple event emitter for cross-component communication
 * 
 * Used for:
 * - SignalR events
 * - Global notifications
 * - Cross-component messaging
 */
import TinyEmitter from 'tiny-emitter';

const emitter = new TinyEmitter();

const EventHub = {
    /**
     * Subscribe to an event
     * @param {string} event - Event name
     * @param {Function} callback - Event handler
     */
    $on(event, callback) {
        emitter.on(event, callback);
    },

    /**
     * Subscribe to an event (once)
     * @param {string} event - Event name
     * @param {Function} callback - Event handler
     */
    $once(event, callback) {
        emitter.once(event, callback);
    },

    /**
     * Unsubscribe from an event
     * @param {string} event - Event name
     * @param {Function} callback - Event handler to remove
     */
    $off(event, callback) {
        emitter.off(event, callback);
    },

    /**
     * Emit an event
     * @param {string} event - Event name
     * @param {...any} args - Event arguments
     */
    $emit(event, ...args) {
        emitter.emit(event, ...args);
    }
};

export default EventHub;
